import R from 'ramda';
import {
  INIT_VIDEO,
  SET_TOGGLE_VIDEO_PLAY_PAUSE,
  SET_VIDEO_VOLUME,
  SET_TOGGLE_VIDEO_MUTED,
  SET_VIDEO_PROGRESS,
  SET_VIDEO_DURATION,
  SET_VIDEO_SEEKING,
  SET_VIDEO_STOPPED,
  SET_VIDEO_MILESTONE,
  RESET_VIDEO_MILESTONE,
  SET_MEDIA_PLAY,
} from './types';

const initVideo = (state, { muted, volume, id }) => ({
  ...state,
  [id]: {
    ...state[id],
    muted,
    volume,
    milestones: {
      tracked25: false,
      tracked50: false,
      tracked75: false,
    },
    milestone: undefined,
    mediaPlay: false,
  },
});

const setTogglePlayPause = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    playing: !state[id].playing,
  },
});

const setVolume = (state, { volume, id }) => ({
  ...state,
  [id]: {
    ...state[id],
    volume,
    muted: !volume,
  },
});

const setToggleMuted = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    muted: !state[id].muted,
    volume: state[id].muted ? 1 : 0,
  },
});

const setProgress = (state, { progress, id }) => ({
  ...state,
  [id]: {
    ...state[id],
    progress,
  },
});

const setDuration = (state, { duration, id }) => ({
  ...state,
  [id]: {
    ...state[id],
    duration,
  },
});

const setSeeking = (state, { seeking, id }) => ({
  ...state,
  [id]: {
    ...state[id],
    seeking,
  },
});

const setStopped = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    playing: false,
  },
});

const getVideoMilestone = ({
  videoPercentage,
  tracked25,
  tracked50,
  tracked75,
}) => {
  // needed because the percentage doesn't always round up to the milestone (25, 50, etc)
  const result = {
    tracked25,
    tracked50,
    tracked75,
    milestone: undefined,
  };
  if (!tracked25 && (videoPercentage > 24 && videoPercentage < 29)) {
    return { ...result, tracked25: true, milestone: 25 };
  } else if (!tracked50 && (videoPercentage > 49 && videoPercentage < 54)) {
    return { ...result, tracked50: true, milestone: 50 };
  } else if (!tracked75 && (videoPercentage > 74 && videoPercentage < 79)) {
    return { ...result, tracked75: true, milestone: 75 };
  }
  return result;
};

const setMilestone = (state, { percentage, id }) => {
  const {
    milestone,
    tracked25,
    tracked50,
    tracked75,
  } = getVideoMilestone({
    videoPercentage: percentage,
    tracked25: R.path(['milestones', 'tracked25'])(state[id]),
    tracked50: R.path(['milestones', 'tracked50'])(state[id]),
    tracked75: R.path(['milestones', 'tracked75'])(state[id]),
  });

  return {
    ...state,
    [id]: {
      ...state[id],
      milestones: {
        tracked25,
        tracked50,
        tracked75,
      },
      milestone,
    },
  };
};

export const resetMilestone = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    milestones: {
      tracked25: false,
      tracked50: false,
      tracked75: false,
    },
    mediaPlay: false,
  },
});

export const setMediaPlay = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    mediaPlay: true,
  },
});


const reducer = {
  [INIT_VIDEO]: initVideo,
  [SET_TOGGLE_VIDEO_PLAY_PAUSE]: setTogglePlayPause,
  [SET_VIDEO_VOLUME]: setVolume,
  [SET_TOGGLE_VIDEO_MUTED]: setToggleMuted,
  [SET_VIDEO_PROGRESS]: setProgress,
  [SET_VIDEO_DURATION]: setDuration,
  [SET_VIDEO_SEEKING]: setSeeking,
  [SET_VIDEO_STOPPED]: setStopped,
  [SET_VIDEO_MILESTONE]: setMilestone,
  [RESET_VIDEO_MILESTONE]: resetMilestone,
  [SET_MEDIA_PLAY]: setMediaPlay,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
